export const numbersToPercentage = (n1, n2, noDecimals = false) => (
  Number(n1 / n2).toLocaleString('en-US', {
    style: 'percent',
    maximumFractionDigits: noDecimals ? 0 : 2,
    minimumFractionDigits: noDecimals ? 0 : 2,
  })
)
